import { importFileModalReducerKey } from './ImportFileModalConstants';

export const importFileModal = (state) => state.get(importFileModalReducerKey);

export const isLoading = (state) => importFileModal(state).get('isLoading');

export const isClosed = (state) => importFileModal(state).get('isClosed');

export const uploadedFile = (state) => importFileModal(state).get('uploadedFile');
